import { combine, createApi, createDomain } from 'effector';
import type { GeneralID } from '@types';
import { $sceneMap } from './dataStores';

const domain = createDomain('loaded');

export const $loadedId = domain.store<null | GeneralID>(null);
export const $loadedIdApi = createApi($loadedId, {
  set: (_, id: GeneralID) => id,
  unset: () => null,
});

export const $loadedScene = combine($sceneMap, $loadedId, (map, id) => {
  if (!id) return null;
  return map.get(id) ?? null;
});
